import Component from '../component';
import CookiesManager from '../../helpers/cookies-manager';

export default class ProductInnovationPopin extends Component {
    constructor(...args) {
        super(...args);

        this.init();
    }
    init() {
        this.dom.close = this.dom.component.querySelector('.js-close-button-popin');
        this.dom.link = this.dom.component.querySelector('.js-link-popin');
    }
    bind() {
        super.bind();

        //Check is new visitor
        let cookie = CookiesManager.check('firstArrival');
        //Check is popin are close
        let cookie2 = CookiesManager.check('closePopinProduct');

        if ( !cookie ){
            window.setTimeout(() =>{
                this._togglePopin(0.5);
                CookiesManager.set('firstArrival', true, 1);
            } , 10000);
        }

        if ( !cookie2 ){

            if( cookie)
                this._togglePopin(0);

            this.dom.close.addEventListener('click', () =>{
                CookiesManager.set('closePopinProduct', true, 1);
                this._togglePopin(0.3, 0);
            });

            this.dom.link.addEventListener('click', () => {
                CookiesManager.set('closePopinProduct', true, 1);
            });
        }
    }

    _togglePopin( duration, autoAlpha = 1 ) {
        TweenLite
            .to(this.dom.component, duration, {
            autoAlpha: autoAlpha,
            ease: Power3.easeOut
            });
    }

    /*

    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/product-innovation-popin/product-innovation-popin.js